<template>
	<v-card>
		<v-card-title class="py-2 primary">
			<span class="tertiary--text">Note Pratica</span>
		</v-card-title>
		<v-card-text>
			<v-row class="font-weight-medium" style="font-size: 18px">
				<v-col class="mt-6">
					<div>ID: {{ pratica.custom_id }}</div>
					<div>Ragione Sociale Cliente: {{ pratica.accordo.cliente.ragione_sociale }}</div>
					<div>Cognome Cliente: {{ pratica.accordo.cliente.cognome }}</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-textarea
						outlined
						class="mt-1"
						:value="pratica.notes"
						@input="pratica.notes = $event !== '' ? $event : null"
					></v-textarea>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				@click="close()"
				:disabled="isSaving"
				class="black--text"
			>
				{{ pratica.notes !== backupPratica.notes ? 'Annulla' : 'Chiudi' }}
			</v-btn>
			<v-btn
				color="secondary"
				@click="update()"
				:disabled="isSaving || pratica.notes === backupPratica.notes"
				:loading="isSaving"
			>
				Salva
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {eventBus} from '@/event-bus';
export default {
	props: {
		value: {
			default: null
		},
		showInfoPratica: {
			default: false
		}
	}, // pratica object
	
	data() {
		return {
			backupPratica: null,
			pratica: {
				id: null,
				custom_id: null,
				ragione_sociale: null,
				notes: null
			},
			isSaving: false
		}
	},
	
	created() {
		this.backupPratica = Object.assign({}, this.value);
		this.pratica = Object.assign({}, this.value);
	},
	
	methods: {
		update() {
			this.isSaving = true;
			let pratica = {
				id: this.pratica.id,
				notes: this.pratica.notes
			}
			let formData = new FormData();
			formData.append('pratica', JSON.stringify(pratica));
			axios.patch(`/api/pratiche/${pratica.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.$emit('input', this.pratica);
					this.$emit('pratica-updated', {
						praticaAggiornata: this.pratica
					})
					this.close();
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		close() {
			this.$emit('close');
		}
	}
}
</script>